function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4066 14.3747H9.84375C9.585 14.3747 9.375 14.5847 9.375 14.8434V16.4062C9.375 16.665 9.585 16.875 9.84375 16.875H11.4066C11.6653 16.875 11.8753 16.665 11.8753 16.4062V14.8434C11.8753 14.5847 11.6653 14.3747 11.4066 14.3747Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4066 18.1247H9.84375C9.585 18.1247 9.375 18.3347 9.375 18.5934V20.1562C9.375 20.415 9.585 20.625 9.84375 20.625H11.4066C11.6653 20.625 11.8753 20.415 11.8753 20.1562V18.5934C11.8753 18.3347 11.6653 18.1247 11.4066 18.1247Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.781 14.3747H14.2181C13.9594 14.3747 13.7494 14.5847 13.7494 14.8434V16.4062C13.7494 16.665 13.9594 16.875 14.2181 16.875H15.781C16.0397 16.875 16.2497 16.665 16.2497 16.4062V14.8434C16.2497 14.5847 16.0397 14.3747 15.781 14.3747Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.781 18.1247H14.2181C13.9594 18.1247 13.7494 18.3347 13.7494 18.5934V20.1562C13.7494 20.415 13.9594 20.625 14.2181 20.625H15.781C16.0397 20.625 16.2497 20.415 16.2497 20.1562V18.5934C16.2497 18.3347 16.0397 18.1247 15.781 18.1247Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1562 14.3747H18.5934C18.3346 14.3747 18.1246 14.5847 18.1246 14.8434V16.4062C18.1246 16.665 18.3346 16.875 18.5934 16.875H20.1562C20.4149 16.875 20.6249 16.665 20.6249 16.4062V14.8434C20.6249 14.5847 20.4149 14.3747 20.1562 14.3747Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.625 9.375H9.375C8.34094 9.375 7.5 10.2159 7.5 11.25V13.1503V20.625C7.5 21.6591 8.34094 22.5 9.375 22.5H20.625C21.6591 22.5 22.5 21.6591 22.5 20.625V13.1503V11.25C22.5 10.2159 21.6591 9.375 20.625 9.375ZM21.2503 20.625C21.2503 20.97 20.97 21.2503 20.625 21.2503H9.375C9.03 21.2503 8.74969 20.97 8.74969 20.625V13.7747H21.2494V20.625H21.2503Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 7.5H10.6247C10.2797 7.5 9.99939 7.77937 9.99939 8.12531V10.6256C9.99939 10.9706 10.2788 11.2509 10.6247 11.2509H11.25C11.595 11.2509 11.8753 10.9716 11.8753 10.6256V8.12531C11.8753 7.77937 11.595 7.5 11.25 7.5Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3754 7.5H18.7501C18.4051 7.5 18.1248 7.77937 18.1248 8.12531V10.6256C18.1248 10.9706 18.4051 11.25 18.7501 11.25H19.3754C19.7204 11.25 20.0007 10.9706 20.0007 10.6247V8.12531C19.9998 7.77937 19.7204 7.5 19.3754 7.5Z"
});

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6f4ce478.svg";
export { ForwardRef as ReactComponent };